import {
  observable, set,
} from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import { NOTIFICATION_GROUP, NOTIFICATION_TYPE } from '../../../constants/Notifications';

export interface INotificationOptions {
  key: string;
  severity?: string;
  group?: NOTIFICATION_GROUP;
  type?: NOTIFICATION_TYPE;
  timeout?: number;
  error?: TypeError;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
}

class Notification implements INotificationOptions {
  @observable key: string;

  @observable data?: {
    data?: {
      offer_code?: string;
      products?: string[] | string;
    };
  };

  @observable productRgnName?: string;

  @observable severity?: string;

  @observable offerRemoved?: string;

  @observable group?: NOTIFICATION_GROUP;

  @observable error?: TypeError;

  @observable type?: NOTIFICATION_TYPE = NOTIFICATION_TYPE.DANGER;

  timeout?: number;

  uuid?: string = uuidv4();

  static fromJSON(data: INotificationOptions): Notification {
    const error = new Notification();
    set(error, data);

    return error;
  }

  get products(): string[] {
    return this.data?.data?.products as string[];
  }
}

export default Notification;
